import { render, staticRenderFns } from "./TrainingSummaries.vue?vue&type=template&id=dae8ad8e&"
import script from "./TrainingSummaries.vue?vue&type=script&lang=js&"
export * from "./TrainingSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports